var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB1BatteryEmpry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#B1_Battery_empry_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 51.14V24.92A4 4 0 0110 21h37.57l-4.32 4H10v26h5.2l-4.32 4H10a4 4 0 01-4-3.86zM76 5.56L59.35 21h2.73A4 4 0 0166 25v6h5v14h-5v6.08A4 4 0 0162 55H22.66L0 76v-5.45L76 .1v5.46zM55 25L27 51h35V25h-7z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "B1_Battery_empry_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h76v76H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/B1_Battery_empry.276a4cc1.svg";
export { SvgB1BatteryEmpry as ReactComponent };